import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class VisaFormService {
  async getSmartserviceList() {
    try {
      const response = await HttpClient.get("/api/visaform/smartservice/list");
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartserviceListLTR() {
    try {
      const response = await HttpClient.get(
        "/api/visaform/smartservice/list?smartserviceGroupID=LTR"
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartserviceListLTRExtra() {
    try {
      const response = await HttpClient.get(
        "/api/visaform/smartservice/list?smartserviceGroupID=LTR&isExtra=true&TypeDocSmartFromID=W"
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartserviceList2(body) {
    try {
      const params = qs.stringify({
        ...(body &&
          body.smartserviceId && { smartserviceId: body.smartserviceId }),
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body &&
          body.TypeDocSmartFromID && {
          TypeDocSmartFromID: body.TypeDocSmartFromID,
        }),
        ...(body && body.StatausID && { StatausID: body.StatausID }),
        ...(body &&
          body.resonsibleCase && { resonsibleCase: body.resonsibleCase }),
        ...(body && body.keyword && { keyword: body.keyword }),
        ...(body && body.isActivated && { isActivated: body.isActivated }),
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
        ...(body &&
          body.statusProcessId && { statusProcessId: body.statusProcessId }),
      });

      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list2?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartserviceListPreApprove(body) {
    try {
      const params = qs.stringify({
        ...(body &&
          body.smartserviceId && { smartserviceId: body.smartserviceId }),
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body &&
          body.TypeDocSmartFromID && {
          TypeDocSmartFromID: body.TypeDocSmartFromID,
        }),
        ...(body && body.StatausID && { StatausID: body.StatausID }),
        ...(body &&
          body.resonsibleCase && { resonsibleCase: body.resonsibleCase }),
        ...(body && body.keyword && { keyword: body.keyword }),
        ...(body && body.isActivated && { isActivated: body.isActivated }),
        ...(body && body.startDate && { startDate: body.startDate }),
        ...(body && body.endDate && { endDate: body.endDate }),
      });

      const response = await HttpClient.get(
        `/api/stampfrom/admin/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getDocumentRequired({
    smartserviceId,
    ConditionType,
    isUpload,
    smartserviceGroupID,
  }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(ConditionType && { ConditionType }),
        ...(smartserviceGroupID && { smartserviceGroupID }),

        isUpload: isUpload === undefined ? true : isUpload,
      });
      const response = await HttpClient.get(
        `/api/visaform/documentrequired/list?${params}`
      );
      // console.log(response);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
  async getDocumentRequiredPreApprove({
    smartserviceId,
    ConditionType,
    isUpload,
    smartserviceGroupID,
    draftId,
  }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(ConditionType && { ConditionType }),
        ...(smartserviceGroupID && { smartserviceGroupID }),
        ...(draftId && { draftId }),

        isUpload: isUpload === undefined ? true : isUpload,
      });
      const response = await HttpClient.get(
        `/api/stampfrom/documentrequired/list?${params}`
      );
      // console.log(response);

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getDocumentrequiredbydraftid({ draftId, isUpload }) {
    try {
      const params = qs.stringify({
        ...(draftId && { draftId }),
        isUpload: isUpload === undefined ? true : isUpload,
      });
      const response = await HttpClient.get(
        `/api/visaform/documentrequiredbydraftid/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getCoditionvisa({ smartserviceId, ConditionType }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(ConditionType && { ConditionType }),
      });
      const response = await HttpClient.get(
        `/api/visaform/coditionvisa/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getCoditionType({ smartserviceId }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
      });
      const response = await HttpClient.get(
        `/api/visaform/coditiontype/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getConditionShowLtr(body) {
    try {
      const params = qs.stringify({
        ...(body.personalId && { personalId: body.personalId }),
      });
      const response = await HttpClient.get(
        `/api/visaform/smartfrom/checkshow?${params}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartFormFieldConfig({
    smartserviceId,
    partfromId,
    smartserviceGroupID,
  }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(smartserviceGroupID && { smartserviceGroupID }),

        ...(partfromId && { partfromId }),
      });
      const response = await HttpClient.get(
        `/api/visaform/partsmart/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartForm(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfrom/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getListSmartForm({ personalId }) {
    const params = qs.stringify({
      ...(personalId && { personalId }),
    });

    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getSmartForm({
    personalId,
    smartserviceId,
    draftId,
    smartserviceGroupID,
  }) {
    const params = qs.stringify({
      ...(personalId && { personalId }),
      ...(smartserviceId && { smartserviceId }),
      ...(smartserviceGroupID && { smartserviceGroupID }),

      ...(draftId && { draftId }),
    });
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartfrom/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkRequestSmartForm({ personalId, isRequest }) {
    const params = qs.stringify({
      isRequest: true,
      ...(personalId && { personalId }),
    });
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartfrom/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadDocumentCondition({
    file,
    personalID,
    conditionId,
    configConditionVisaId,
  }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);
      formData.append("conditionId", conditionId);
      formData.append("configConditionVisaId", configConditionVisaId);
      formData.append("draftId", null);

      const response = await HttpClient.post(
        `/api/visaform/coditionvisa/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadEducationDocument({ file, personalID, fileID }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);
      if (fileID) {
        formData.append("fileID", fileID);
      }

      const response = await HttpClient.post(
        `/api/visaform/education/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadProcessDiagram({ file, personalID, fileID }) {
    try {
      const formData = new FormData();
      formData.append("FileUpload", file);
      formData.append("personalID", personalID);
      if (fileID) {
        formData.append("fileID", fileID);
      }

      const response = await HttpClient.post(
        `/api/visaform/processdiagram/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadFileDocument({
    file,
    fileID,
    typedocId,
    personalID,
    documentID,
    Status,
    draftId,
  }) {
    try {
      const formData = new FormData();
      formData.append("personalID", personalID);
      formData.append("typedocId", typedocId);
      formData.append("documentID", documentID);
      formData.append("Status", Status);

      if (file) {
        formData.append("FileUpload", file);
      }

      if (fileID) {
        formData.append("fileID", fileID);
      }
      if (draftId) {
        formData.append("draftId", draftId);
      }

      const response = await HttpClient.post(
        `/api/visaform/filedocument/upload`,
        formData,
        true
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async submitSmartForm({ draftId }) {
    try {
      const response = await HttpClient.post(`/api/visaform/smartfrom/send`, {
        draftId,
      });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async submitSmartO({ draftId }) {
    try {
      const response = await HttpClient.post(`/api/visaform/smarto/submit`, {
        draftId,
      });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async submitSmartDependent({ draftId, relationshipID }) {
    try {
      const response = await HttpClient.post(`/api/visaform/smarto/submit`, {
        draftId,
        relationshipID,
      });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async smartFormChange({ personalId }) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromchange/gen`,
        {
          personalId,
        }
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async conditionAdd({ detail = [] }) {
    try {
      const response = await HttpClient.post(`/api/visaform/condition/add`, {
        detail,
      });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async smartfromExtension({ personalId }) {
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartfromold/list?personalId=${personalId}&smartserviceIdNewFrom=ea67ab08-5953-4453-0830-28ed243a8d38`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addExtension(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfromextension/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkSmartO({ SmartNo }) {
    try {
      const params = qs.stringify({
        SmartNo,
      });

      const response = await HttpClient.get(
        `/api/visaform/smartfrom/checko?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async reqdoclogAdd({ draftId, detail }) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartfrom/reqdoclog/add`,
        { draftId, detail }
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async reqdoclogList(data) {
    try {
      const params = qs.stringify(data);
      const response = await HttpClient.get(
        `/api/visaformadmin/smartfrom/reqdoc/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkExistingSmart({ personalID }) {
    try {
      const params = qs.stringify({
        personalID,
      });

      const response = await HttpClient.get(
        `/api/visaform/smartextra/check?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async checkWorkPermit(body) {
    try {
      const params = qs.stringify({
        ...(body.personalId && { personalId: body.personalId }),
        ...(body.isWorkpermitEditor && { isWorkpermitEditor: body.isWorkpermitEditor }),
      });
      const response = await HttpClient.get(
        `/api/visaform/workpermit/check?${params}`
      );

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addWorkPermit(data) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/workpermit/add`,
        data
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getDigitalWorkpermitList(body) {
    try {
      const params = qs.stringify({
        ...(body.personalId && { personalId: body.personalId }),
      });
      const response = await HttpClient.get(
        `/api/visaform/smartfrom/dwphistory/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new VisaFormService();
